import React from 'react';
import Image from '@telia-front/image';
const MainBackground = (props) => {
    const { className, pullBottom, imageLeft, imageRight, imageBottom } = props;
    const BEM = () => {
        const classArray = ['main__background'];
        if (pullBottom) {
            classArray.push('main__background--pull-bottom');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM() },
        React.createElement("div", { className: "main__background-inner" },
            imageLeft && (React.createElement("div", { className: "main__background-item main__background-item--left" },
                React.createElement(Image, Object.assign({}, imageLeft)))),
            imageRight && (React.createElement("div", { className: "main__background-item main__background-item--right" },
                React.createElement(Image, Object.assign({}, imageRight)))),
            imageBottom && (React.createElement("div", { className: "main__background-item main__background-item--bottom" },
                React.createElement(Image, Object.assign({}, imageBottom)))))));
};
export { MainBackground as default, };
